import { SIGN_SUCESS } from "./action-types";

const { Storage } = require("../../../../configs/lib");
const initialState = {};

export const signIn = (
  state = initialState,
  { type, payload = "" }: any
): any => {
  switch (type) {
    case SIGN_SUCESS:
      return signIN(state, payload);
    default:
      return state;
  }
};

function signIN(state: any, payload: any) {
  Storage.setItem("adminToken", payload);
  Storage.setItem("userRole", "admin");

  return {
    ...state,
  };
}
